// src/components/BlogUploader.js
import React, { useState } from 'react';
import { db } from '../firebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import '../styles/BlogsPage.css'; // <<-- PATH CHANGED TO USE MAIN CSS FILE

const BlogUploader = ({ dietitianUid, dietitianName }) => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [tags, setTags] = useState('');
    const [status, setStatus] = useState('draft'); 
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setLoading(true);

        const tagsArray = tags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);

        const newBlogPost = {
            title,
            content,
            tags: tagsArray,
            authorId: dietitianUid,
            authorName: "Nutrition Trends",
            status: status,
            createdAt: serverTimestamp(),
            lastUpdated: serverTimestamp(),
        };

        try {
            await addDoc(collection(db, 'blogs'), newBlogPost); 
            setMessage(`Blog post saved successfully as ${status}!`);
            setTitle('');
            setContent('');
            setTags('');
            setStatus('draft');
        } catch (error) {
            console.error('Error adding document: ', error);
            setMessage('Failed to save blog post. Check console for details.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="blog-uploader-form" onSubmit={handleSubmit}>
            <div className="form-group">
                <label htmlFor="title">Title:</label>
                <input
                    id="title"
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                    placeholder="E.g., 5 Simple Steps to Better Sleep"
                />
            </div>

            <div className="form-group">
                <label htmlFor="content">Content (Markdown supported):</label>
                <textarea
                    id="content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                    rows="10"
                    placeholder="Start writing your amazing blog post here..."
                />
            </div>
            
            <div className="form-group">
                <label htmlFor="tags">Tags (comma separated):</label>
                <input
                    id="tags"
                    type="text"
                    value={tags}
                    onChange={(e) => setTags(e.target.value)}
                    placeholder="e.g., nutrition, weight-loss, mindset"
                />
            </div>
            
            <div className="form-actions">
                <button 
                    type="submit" 
                    disabled={loading}
                    onClick={() => setStatus('draft')} 
                    className="btn btn-save-draft"
                >
                    {loading && status === 'draft' ? 'Saving...' : 'Save Draft'}
                </button>
                
                <button 
                    type="submit" 
                    disabled={loading || !title || !content}
                    onClick={() => setStatus('published')} 
                    className="btn btn-publish"
                >
                    {loading && status === 'published' ? 'Publishing...' : 'Publish Blog'}
                </button>
            </div>
            
            {message && <p className="submission-message">{message}</p>}
        </form>
    );
};

export default BlogUploader;